export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/57a43ba76340ea303ae7dc89733370a0.svg";